var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.rootClass,
      attrs: {
        title: _vm.title,
        "aria-expanded": _vm.ariaExpandedAttr,
        "aria-controls": _vm.ariaControlsAttr,
        "aria-label": _vm.ariaLabelAttr,
        type: "button"
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        },
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _vm.active && !_vm.collapsed
        ? _c("span", { staticClass: "nav-item__bar" })
        : _vm._e(),
      _c(
        "span",
        { staticClass: "nav-item__icon" },
        [
          _c("icon-svg", {
            staticClass: "navbar-main-icon",
            class: {
              "is-detailed": _vm.isDetailedIcon,
              "is-animating": _vm.iconAnimating
            },
            attrs: {
              name: _vm.item.icon,
              size: _vm.ICON_SIZE,
              color: _vm.iconColor
            }
          })
        ],
        1
      ),
      !_vm.collapsed
        ? _c("span", { staticClass: "nav-item__label" }, [
            _vm._v(_vm._s(_vm.item.label))
          ])
        : _vm._e(),
      !_vm.collapsed && _vm.noAccess
        ? _c("IconNoModuleAccess", {
            staticClass: "nav-item__no-access",
            attrs: {
              iconSize: _vm.NO_ACCESS_ICON_SIZE,
              lockNavBarOnHover: "",
              module: _vm.item.label,
              "content-class": "nav-item-no-access-menu"
            }
          })
        : _vm._e(),
      !_vm.collapsed && _vm.item.badge
        ? _c(
            "span",
            {
              staticClass: "nav-item__badge",
              class: { "nav-item__badge--new": _vm.isNewBadge }
            },
            [_vm._v(_vm._s(_vm.item.badge))]
          )
        : _vm._e(),
      _vm.showChevron
        ? _c(
            "span",
            { staticClass: "nav-item__chevron" },
            [
              _c("icon-svg", {
                attrs: {
                  name: _vm.chevronIcon,
                  size: _vm.CHEVRON_SIZE,
                  color: _vm.navFg
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }